export default "__VITE_ASSET__e34f175f__"